import React, { useState } from 'react';
import { connect } from "react-redux";
import * as actions from "redux/actions/stockOrderActions";
import { Translate } from "react-redux-i18n";
import { Edit } from 'theme/icon';

function buildReferenceValues(item, userId) {
    return {
        stock_id: item?.id ?? '',
        reference: item?.reference ?? '',
        id: userId ?? '',
        symbol: item?.symbol ?? '',
    };
}

const FormDialog = (props) => {
    const [open, setOpen] = React.useState(false);

    const [values, setValue] = useState(() => buildReferenceValues(props.item, props.user_id));

    const handleClickOpen = (event) => {
        event?.stopPropagation?.();
        if (!props.item?.symbol) {
            return;
        }
        setValue(buildReferenceValues(props.item, props.user_id));
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        if (!props.item?.symbol || !props.user_id) {
            return;
        }
        props.updateReference(props.token, {
            ...values,
            reference: values.reference ?? '',
            symbol: props.item.symbol,
            id: props.user_id,
            stock_id: props.item.id ?? values.stock_id,
        });
        setOpen(false);
    };

    const handleChange = (event) => {
        const name = event?.target?.name;
        if (!name) {
            return;
        }
        const { value } = event.target;
        setValue((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    if (!props.item?.symbol) {
        return null;
    }

    return (
        <div style={{ display: 'inline' }}>
            <span onClick={handleClickOpen} size="small">
                <Edit />
            </span>
            {open && (
                <div
                    className="dialog"
                    onClick={handleClose}
                    onKeyDown={(event) => {
                        if (event.key === 'Escape') {
                            handleClose();
                        }
                    }}
                    role="presentation"
                >
                    <div
                        className="dialog-content dialog-content--reference"
                        onClick={(event) => event.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="reference-modal-title"
                    >
                        <div className="dialog-title" id="reference-modal-title">Reference</div>
                        <div className="dialog-content-text">
                            Enter Description
                        </div>
                        <input
                            autoFocus
                            id="reference"
                            name="reference"
                            required
                            type="text"
                            onChange={handleChange}
                            value={values.reference || ''}
                        />
                        <div className="dialog-actions">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}
                            >
                                <Translate value="cancel" />
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSave}
                            >
                                <Translate value="save" />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
    };
}

const mapDispatchToProps = dispatch => ({
    updateReference: (token, params) =>
        dispatch(actions.updateReference({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
